import { render, staticRenderFns } from "./Block2Item.vue?vue&type=template&id=508ee5d2&scoped=true&"
import script from "./Block2Item.vue?vue&type=script&lang=js&"
export * from "./Block2Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ee5d2",
  null
  
)

export default component.exports